<!-- promotionList -->
<template>
  <ul class="promotionDetailList">
    <li
      v-for="(promotion, index) in promotionListValid"
      :key="index"
      v-if="!(promotion.type === couponType && !selectable&&memberPackage)"
      :class="['promotionDetail', { promotionDetailCoupon: promotion.type === couponType }]"
      @click="promotionClickHandle(promotion)"
    >
      <p class="promotionDetailName">
        <span>{{ promotionTypeMap[promotion.type] }}</span>
        <!-- <span
          v-if="promotion.type === couponType && promotion.available && promotion.couponName" -->
        <span v-if="promotion.type === couponType && promotion.isRecommend" class="couponName"
          >已选择推荐优惠</span
        >
      </p>
      <p class="promotionDetailPrice">
        <span class="unSelectableText" v-if="promotion.type === couponType && !selectable"
          >无可用优惠券</span
        >
        <span v-else>-￥{{ promotion.price }}</span>
        <button v-if="promotion.type === couponType" class="couponSelectButton"></button>
      </p>
    </li>
  </ul>
</template>

<script>
import { promotionTypeMap, COUPON_TYPE } from '@/assets/js/payConfig';

export default {
  props: {
    promotionList: {
      type: Array,
      default: () => [],
    },
    couponList: {
      type: Array,
      default: () => [],
    },
    memberPackage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    promotionListValid() {
      return this.promotionList.filter(
        (promotion) => promotion.price || promotion.type === this.couponType,
      );
    },
    selectable() {
      return this.couponList.some((coupon) => Number(coupon.available) === 1);
    },
  },
  data() {
    return {
      promotionTypeMap,
      couponType: COUPON_TYPE,
    };
  },
  methods: {
    promotionClickHandle(promotion) {
      if (promotion.type !== this.couponType) return;
      this.$emit('selectCoupon');
    },
  },
};
</script>

<style lang="scss" scoped>
.promotionDetailList {
  .promotionDetail {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 94px;
    color: #333;
    font-size: 25px;
    border-bottom: 2px solid #f5f5f6;

    .promotionDetailName {
      display: flex;
      align-items: center;

      .couponName {
        height: 33px;
        margin-left: 14px;
        padding: 0 13px;
        color: #ff6c02;
        font-size: 22px;
        line-height: 30px;
        border: 2px solid #ff6c02;
        border-radius: 4px;
      }
    }

    .promotionDetailPrice {
      display: flex;
      align-items: center;
      color: #ff6c02;
      font-size: 22px;

      .couponSelectButton {
        width: 43px;
        height: 43px;
        background: url('../../../assets/img/payment/go_detail.png') no-repeat center;
        background-size: contain;
        cursor: pointer;
      }

      .unSelectableText {
        color: #a5a5a5;
      }
    }

    &Coupon {
      cursor: pointer;
    }
  }
}
</style>
